import { mergeStyleSets } from "@fluentui/react";

export const useSearchBar = () => {
  const classNames = mergeStyleSets({
    searchBar: {
      border: "none !important",
      boxShadow: "none !important",
      borderBottom: "2px solid #d8d8d8!important",
      borderRadius: "0px !important",
      padding: "2px !important",
    },
    icon: {
      position: "absolute",
      right: "0",
    },
    formField: {
      position: "relative",
      display: "inline-block",
      width: "100%",
    },
  });
  return {
    classNames,
  };
};
